import React, { useCallback, useMemo } from 'react'
import { useLocation } from 'react-router'
import { useNavigate } from 'react-router-dom'
import Icon from '@components/Icon/Icon'
import { Button, MenuItemChildren, MenuItemContainer } from './MenuItem.styles'

type Props = {
  title: string
  icon?: string
  path: string|string[]
  children?: React.ReactNode
}

const MenuItem: React.FC<Props> = ({ title, icon, path, children }: Props) => {
  const navigate = useNavigate()
  const location = useLocation()

  const handleMenuClick = useCallback(() => navigate(typeof path === 'string' ? path : path[0]), [navigate, path])

  const isActive = useMemo(() => {
    if (Array.isArray(path))
      return path.some(p => location.pathname.startsWith(p))

    if (path === '/' || location.pathname === '/')
      return location.pathname === path

    return location.pathname.startsWith(path)
  }, [location.pathname, path])

  return (
    <MenuItemContainer className="menu-item">
      <Button className={(isActive ? ' is-active' : '')} onClick={handleMenuClick}>
        <div className="btn-inner">
          {icon && (
            <div className="icon">
              <Icon name={icon} />
            </div>
          )}
          <div className="title">{title}</div>
        </div>
      </Button>

      {isActive && children && (
        <MenuItemChildren className="menu-item-children">{children}</MenuItemChildren>
      )}
    </MenuItemContainer>
  )
}

export default MenuItem
